import background from './backgrounds/background-nature.jpg' ;

export default background;